module.exports = __webpack_public_path__ + "img/common_guide_01_m.37aca791.png";